import React, {useMemo, useState} from 'react';
import {View, Modal, Platform} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import TimePickerView, {TimeType} from 'react-native-wheel-time-picker';

import Text from '../../elements/Text';
import Divider from '../../elements/Divider';
import Button from '../../elements/Button';

import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../../theme';
import {BUTTON_TYPES} from '../../../utils/Constants';
import CommonStyles from '../../../utils/CommonStyles';
import {tID} from '../../../utils/TestIdHelper';

const MILLISECONDS_PER_MINUTE = 60 * 1000;
const MILLISECONDS_PER_HOUR = 60 * 60 * 1000;
const MILLISECONDS_PER_DAY = 24 * MILLISECONDS_PER_HOUR;

const TimePicker = ({
  visible = false,
  title = 'Measurement Time',
  onClose = () => {},
}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  const [timeValue, setTimeValue] = useState(
    (Date.now() - new Date().getTimezoneOffset() * MILLISECONDS_PER_MINUTE) %
      MILLISECONDS_PER_DAY,
  );
  const timeString = useMemo(() => {
    const hour = Math.floor(timeValue / MILLISECONDS_PER_HOUR);
    const min = Math.floor(
      (timeValue % MILLISECONDS_PER_HOUR) / MILLISECONDS_PER_MINUTE,
    );
    return `${hour < 10 ? '0' : ''}${hour}:${min < 10 ? '0' : ''}${min}`;
  }, [timeValue]);

  return (
    <Modal
      testID={tID('TimePicker-Modal-Main')}
      transparent
      visible={visible}
      onRequestClose={() => onClose(false)}
      animationType="slide"
    >
      <View
        testID={tID('TimePicker-View-Container')}
        style={[styles.container, Platform.OS === 'web' && styles.webContainer]}
      >
        <SafeAreaView
          style={[
            styles.safeareaContainer,
            Platform.OS === 'web' && styles.detailsContainer,
          ]}
        >
          <View style={styles.bottomContainer}>
            <Text
              testID={tID('TimePicker-Text-Title')}
              variation="Headline4Bold"
              color={colors.textPrimary}
              style={Platform.OS === 'web' && CommonStyles.text_center}
            >
              {title}
            </Text>
            <View style={styles.marginTop24}>
              <TimePickerView
                value={timeValue}
                timeFormat={[
                  TimeType.hours12,
                  ':',
                  TimeType.min,
                  TimeType.ampm,
                ]}
                containerStyle={styles.h160}
                wheelProps={{
                  wheelHeight: 120,
                  itemHeight: 35,
                  containerStyle: styles.w60,
                  disabledColor: colors.textDisabled,
                  selectedColor: colors.textHeading,
                }}
                textStyle={[
                  styles.timePickerText,
                  Platform.OS === 'web' && styles.webTextNonSelect,
                ]}
                onChange={newValue => {
                  setTimeValue(newValue);
                }}
              />
            </View>
            <Divider top={16} />
            {Platform.OS === 'web' ? (
              <View style={styles.buttonsContainer}>
                <Text
                  testID={tID('TimePicker-Text-Cancel')}
                  onPress={() => onClose(false)}
                  style={[styles.webButtonText, styles.webBorderedButtonText]}
                >
                  Cancel
                </Text>
                <Text
                  testID={tID('TimePicker-Text-Confirm')}
                  onPress={() => onClose(timeString)}
                  style={[styles.webButtonText, styles.webFilledButtonText]}
                >
                  Confirm
                </Text>
              </View>
            ) : (
              <View style={styles.buttonsContainer}>
                <Button
                  testID={tID('TimePicker-Button-Cancel')}
                  style={[styles.button]}
                  buttonType={BUTTON_TYPES.Bordered}
                  title={'Cancel'}
                  onPress={() => onClose(false)}
                />
                <Button
                  testID={tID('TimePicker-Button-Confirm')}
                  style={[styles.button, styles.ml16]}
                  buttonType={BUTTON_TYPES.Filled}
                  titleColor={colors.textOnAccent}
                  title={'Confirm'}
                  onPress={() => onClose(timeString)}
                />
              </View>
            )}
          </View>
        </SafeAreaView>
      </View>
    </Modal>
  );
};

export default TimePicker;
